import { createContextProvider } from "../components/store-utils";
import { load } from "../loaders/basic-loader";
import { HidebleProp, hidebleProps, ProcedureReportEntry, ProcedureType } from "./procedure-models";

export interface ProcedureReportState {
    data?: ProcedureReportEntry[]
    sorter?: {id: string, asc: boolean}
    hiddenProps?: HidebleProp[]
    hiddenTypes?: ProcedureType[]
    selected?: ProcedureReportEntry
    filter?: string
}

export type ProcedureAction = {type: "setData", data: ProcedureReportEntry[]} |
{type: "numberSorter", id: string, getter: (r: ProcedureReportEntry) => number} |
{type: "toggleProp", prop: HidebleProp} |
{type: "toggleType", proc: ProcedureType} |
{type: "select", selected: ProcedureReportEntry} |
{type: "setFilter", filter: string} 

function numberSorter(state: ProcedureReportState, {id, getter}:{id: string, getter: (r: ProcedureReportEntry) => number}){
    var data = [...state.data];
    var reverse = state.sorter?.id == id && state.sorter?.asc;
    data.sort((a, b) => getter(a) - getter(b))
    if(reverse)
        data.reverse();
    return {
        ...state,
        data,
        sorter: {id, asc: !reverse}
    }
}

function toggleProp(state: ProcedureReportState, prop:HidebleProp):ProcedureReportState{
    if(!state.hiddenProps?.length)
        return {...state, hiddenProps: [prop]}
    return {
        ...state,
        hiddenProps: state.hiddenProps.includes(prop) ? state.hiddenProps.filter(p => p != prop) : [...state.hiddenProps, prop]
    }
}

function toggleTypes(state: ProcedureReportState, proc:ProcedureType):ProcedureReportState{
    if(!state.hiddenProps?.length)
        return {...state, hiddenTypes: [proc]}
    return {
        ...state,
        hiddenTypes: state.hiddenTypes.includes(proc) ? state.hiddenTypes.filter(p => p != proc) : [...state.hiddenTypes, proc]
    }
}

function reducer(state: ProcedureReportState, action: ProcedureAction):ProcedureReportState {
    switch(action.type){
        case "setData" : return {...state, data: action.data};
        case "numberSorter": return numberSorter(state, {id: action.id, getter: action.getter});
        case "toggleProp": return toggleProp(state, action.prop);
        case "toggleType": return toggleTypes(state, action.proc);
        case "select": return {...state, selected: action.selected};
        case "setFilter": return {...state, filter: action.filter};

    }
    return state;
}

export const [ProcedureContext, ProcedureStore] = createContextProvider(reducer, {hiddenProps: ["clicks", "impressions"]})

export async function loadProcedureReport():Promise<ProcedureReportEntry[]>{
    return await load("api/v1/procedure-report")
}